import React, { Component } from 'react';
import { Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import Modal from '../../common/modal/index';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import i18n from 'kodyl-js/i18n/react';
import {
  getOffers,
  cancelSubscription,
  REACTIVATE_SUCCESS,
  reactivate,
  getTransactions
} from '../../redux/modules/subscriptions';
import CreateSubscription from './create';
import Transactions from './transaction/list';
import SubscriptionPanel from './single-panel';
import { getSession } from '../../redux/modules/auth';
import AfterUnsubscription from './after-unsubscription';
import withQuery from 'app/hooks/withQuery';

@connect(
  ({ auth, subscriptions, user }) => ({ auth, subscriptions, user }),
  { cancelSubscription, reactivate, getSession }
)
@i18n
class Subscription extends Component {
  static fetchData({ getState, dispatch }) {
    if (__CLIENT__) {
      const { offers, transactions } = getState().subscriptions;
      return Promise.all([
        !offers.length && dispatch(getOffers()),
        !transactions.list.length && dispatch(getTransactions())
      ]);
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      unsubscribe: false,
      subscription: null,
      showModal: false
    };
  }

  // unsubscribe = (subscriptionId, confirm = false) => () => {
  //   if (confirm) {
  //     this.props.cancelSubscription(subscriptionId);
  //   }
  //   else {
  //     this.setState({ unsubscribe: subscriptionId });
  //   }
  // }

  setSubscription = subscr => {
    this.setState({ subscription: subscr });
  };

  reactivate = subscription => {
    if (subscription.meta.legacyId) {
      return;
    }
    // return this.props.reactivate(subscription.meta.legacyId).then(action => {
    //   if (action.type === REACTIVATE_SUCCESS) {
    //     this.setSubscription(null);
    //     this.setState({ showModal: false });
    //   }
    //   return action;
    // });

    const REACTIVATE_SUBSCRIPTION = `
    mutation ReactivateSubscription($id: ID!) {
      reactivateSubscription(id: $id) {
        id
      }
    }
    `;

    const { mutate } = this.props.mutation;

    mutate(REACTIVATE_SUBSCRIPTION, {
      id: subscription.id
    }).then(res => {
      if (res.data?.reactivateSubscription) {
        this.setSubscription(null);
        this.props.getSession();
        this.setState({ showModal: false });
      }
      return res.data?.reactivateSubscription;
    });
  };

  close = () => {
    this.setState({ showModal: false });
  };

  open = () => {
    this.setState({ showModal: true });
  };

  render() {
    const { subscriptions } = this.props;
    const { transactions } = subscriptions || {};

    return (
      <div>
        {subscriptions && subscriptions.list.length ? (
          <Row>
            {!this.state.subscription ? (
              <div>
                <Col sm={6}>
                  {subscriptions.list.map(subscription => (
                    <SubscriptionPanel
                      key={subscription.id || subscription._id}
                      subscription={subscription}
                      setSubscription={this.setSubscription}
                    />
                  ))}

                  {!subscriptions.subscriber ||
                  Boolean(
                    subscriptions.subscriber &&
                      !subscriptions.list[0].meta.legacyId &&
                      !subscriptions.list[0].renew &&
                      !subscriptions.list[0].nextSubscription
                  ) ? (
                    <button
                      className="btn btn-success reactivate"
                      onClick={() => this.open()}
                    >
                      {this.i18n('Reactivate subscription')}
                    </button>
                  ) : subscriptions.subscriber &&
                    !subscriptions.list[0].active ? (
                    <p>
                      {this.i18n(
                        'Your subscription has been temporarily paused due to outstanding balance'
                      )}
                    </p>
                  ) : null}
                </Col>

                {transactions && transactions.list.length ? (
                  <Col sm={6}>
                    <h3 style={{ marginTop: '0px' }}>
                      {this.i18n('Receipts')}
                    </h3>
                    <Transactions list={transactions.list} />
                  </Col>
                ) : null}
              </div>
            ) : (
              <AfterUnsubscription
                getSession={this.props.getSession}
                subscription={this.state.subscription}
                setSubscription={this.setSubscription}
              />
            )}
          </Row>
        ) : (
          <CreateSubscription offers={subscriptions.offers} />
        )}
        <Modal
          title={this.i18n('Reactivate subscription')}
          onClose={this.close}
          show={this.state.showModal}
          footer={
            <ButtonToolbar>
              <Button onClick={() => this.close()}>{this.i18n('No')}</Button>
              <Button
                style={{ float: 'right' }}
                bsStyle="success"
                onClick={() => this.reactivate(subscriptions.list[0])}
              >
                {this.i18n('Yes')}, {this.i18n('reactivate subscription')}
              </Button>
            </ButtonToolbar>
          }
        >
          {this.i18n('I have read and accept')}{' '}
          <Link to="/info/terms" onClick={this.modalShow}>
            {this.i18n('the subscription and payment terms')}
          </Link>
          , og ønsker at genaktivere min Boligsøgerannonce.
          <br />
        </Modal>
      </div>
    );
  }
}

export default withQuery(Subscription);
